export function getContextAroundMatch(content, query, contextWords = 5) {
  const words = content.split(/\s+/);
  const queryLower = query.toLowerCase();

  for (let i = 0; i < words.length; i++) {
    const wordLower = words[i].toLowerCase();
    if (wordLower.includes(queryLower)) {
      const start = Math.max(0, i - contextWords);
      const end = Math.min(words.length, i + contextWords + 1);
      return words.slice(start, end).join(" ");
    }

    // Handle multi-word phrases
    if (queryLower.includes(wordLower)) {
      const phrase = words
        .slice(i, i + query.split(/\s+/).length)
        .join(" ")
        .toLowerCase();
      if (phrase.includes(queryLower)) {
        const start = Math.max(0, i - contextWords);
        const end = Math.min(
          words.length,
          i + query.split(/\s+/).length + contextWords
        );
        return words.slice(start, end).join(" ");
      }
    }
  }
  return null;
}

export function matchedResults(filteredDocumentationContent, searchQuery) {
  const results = filteredDocumentationContent
    .map((section) => {
      const filteredSection = section.section
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      if (filteredSection) {
        const match = getContextAroundMatch(section.section, searchQuery);
        return {
          section: section.section,
          headings: [],
          role: section.role,
          index: section.index,
          match: match,
        };
      }
      // Filter headings within the section
      const filteredHeadings = section.headings
        .map((heading) => {
          let match = null;
          // Filter content within the heading
          const filteredContent = heading?.content?.filter((content) => {
            const res = content
              .toLowerCase()
              .includes(searchQuery.toLowerCase());
            if (res) {
              const checkMatch = getContextAroundMatch(content, searchQuery);
              if (checkMatch !== null) {
                match = checkMatch;
              }
              return content;
            }
          });

          // Filter subheadings within the heading
          const filteredSubHeadings = heading?.subHeadings
            ?.map((subHeading) => {
              // Filter content within the subheading
              const filteredSubContent = subHeading?.content?.filter(
                (content) => {
                  const res = content
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase());
                  if (res) {
                    const checkMatch = getContextAroundMatch(
                      content,
                      searchQuery
                    );
                    if (checkMatch !== null) {
                      match = checkMatch;
                    }
                    return content;
                  }
                }
              );

              // Filter QA within the subheading
              const filteredQa = subHeading?.qa?.filter((qa) => {
                const res =
                  qa.question
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase()) ||
                  qa.answer.some((answer) =>
                    answer.toLowerCase().includes(searchQuery.toLowerCase())
                  );
                if (res) {
                  const checkMatch = getContextAroundMatch(
                    qa.question,
                    searchQuery
                  );
                  if (checkMatch !== null) {
                    match = checkMatch;
                  }
                  const res1 = qa.answer.some((answer) => {
                    const res2 = answer
                      .toLowerCase()
                      .includes(searchQuery.toLowerCase());
                    if (res2) {
                      const checkMatch = getContextAroundMatch(
                        answer,
                        searchQuery
                      );
                      if (checkMatch !== null) {
                        match = checkMatch;
                      }
                    }
                  });
                  return qa;
                }
              });

              const filteredOuterLi = subHeading?.outerli?.filter((item) =>
                item.toLowerCase().includes(searchQuery.toLowerCase())
              );

              // Filter `innerli` and their content
              const filteredInnerLi = subHeading?.innerli
                ?.map((innerLi) => {
                  const filteredContent = innerLi?.content?.filter(
                    (content) => {
                      const res = content
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase());
                      if (res) {
                        const checkMatch = getContextAroundMatch(
                          content,
                          searchQuery
                        );
                        if (checkMatch !== null) {
                          match = checkMatch;
                        }
                        return content;
                      }
                    }
                  );
                  if (filteredContent?.length > 0) {
                    return { ...innerLi, content: filteredContent };
                  }
                  return null;
                })
                .filter(Boolean);

              const filteredNotes = subHeading?.middleNote?.filter((note) => {
                const res = note?.text
                  ?.toLowerCase()
                  .includes(searchQuery.toLowerCase());

                if (res) {
                  const checkMatch = getContextAroundMatch(
                    note.text,
                    searchQuery
                  );
                  if (checkMatch !== null) {
                    match = checkMatch;
                  }
                  return note.text;
                }
              });
              const filteredMainContent = subHeading?.mainContent?.filter(
                (content) => {
                  const res = content
                    ?.toLowerCase()
                    .includes(searchQuery.toLowerCase());
                  if (res) {
                    const checkMatch = getContextAroundMatch(
                      content,
                      searchQuery
                    );
                    if (checkMatch !== null) {
                      match = checkMatch;
                    }
                    return content;
                  }
                }
              );

              const filteredSecondLayer = subHeading?.secondLayer
                ?.map((item) => {
                  const filteredSecondLayerContent = item?.content?.filter(
                    (text) => {
                      const res = text
                        ?.toLowerCase()
                        .includes(searchQuery.toLowerCase());
                      if (res) {
                        const checkMatch = getContextAroundMatch(
                          text,
                          searchQuery
                        );
                        if (checkMatch !== null) {
                          match = checkMatch;
                        }
                        return text;
                      }
                    }
                  );
                  if (filteredSecondLayerContent?.length) {
                    return { ...item, content: filteredSecondLayerContent };
                  }

                  const filteredSecondLayerInnerLi = item?.innerli
                    ?.map((li) => {
                      const filteredSecondLayerInnerLiContent =
                        li?.content?.filter((content) => {
                          const res = content
                            ?.toLowerCase()
                            .includes(searchQuery.toLowerCase());
                          if (res) {
                            const checkMatch = getContextAroundMatch(
                              content,
                              searchQuery
                            );
                            if (checkMatch !== null) {
                              match = checkMatch;
                            }
                            return content;
                          }
                        });
                      if (filteredSecondLayerInnerLiContent?.length) {
                        return {
                          ...li,
                          content: filteredSecondLayerInnerLiContent,
                        };
                      }
                    })
                    .filter(Boolean);
                  if (filteredSecondLayerInnerLi?.length) {
                    return { ...item, innerli: filteredSecondLayerInnerLi };
                  }
                  return null;
                })
                .filter(Boolean);

              const filteredExtraNote = subHeading?.extraNote
                ?.map((note) => {
                  const filteredTitle = note?.title
                    ?.toLowerCase()
                    .includes(searchQuery.toLowerCase());
                  if (filteredTitle) {
                    const checkMatch = getContextAroundMatch(
                      note?.title,
                      searchQuery
                    );
                    if (checkMatch !== null) {
                      match = checkMatch;
                    }
                    return { ...note, title: filteredTitle };
                  }

                  const filteredNoteContent = note?.content?.filter(
                    (content) => {
                      const res = content
                        ?.toLowerCase()
                        .includes(searchQuery.toLowerCase());
                      if (res) {
                        const checkMatch = getContextAroundMatch(
                          content,
                          searchQuery
                        );
                        if (checkMatch !== null) {
                          match = checkMatch;
                        }
                        return content;
                      }
                    }
                  );
                  if (filteredNoteContent?.length) {
                    return { ...note, content: filteredNoteContent };
                  }
                  return null;
                })
                .filter(Boolean);

              if (
                subHeading?.subHeading
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase()) ||
                filteredSubContent?.length > 0 ||
                filteredQa?.length > 0 ||
                filteredOuterLi?.length > 0 ||
                filteredInnerLi?.length > 0 ||
                filteredNotes?.length > 0 ||
                filteredMainContent?.length ||
                filteredSecondLayer?.length ||
                filteredExtraNote?.length
              ) {
                const checkMatch = getContextAroundMatch(
                  subHeading?.subHeading,
                  searchQuery
                );
                if (checkMatch !== null) {
                  match = checkMatch;
                }
                if (match !== null) {
                  return {
                    ...subHeading,
                    content: filteredSubContent,
                    qa: filteredQa,
                    outerli: filteredOuterLi,
                    innerli: filteredInnerLi,
                    middleNote: filteredNotes,
                    mainContent: filteredMainContent,
                    secondLayer: filteredSecondLayer,
                    extraNote: filteredExtraNote,
                    match: match,
                  };
                } else {
                  return {
                    ...subHeading,
                    content: filteredSubContent,
                    outerli: filteredOuterLi,
                    innerli: filteredInnerLi,
                    qa: filteredQa,
                    middleNote: filteredNotes,
                    mainContent: filteredMainContent,
                    secondLayer: filteredSecondLayer,
                    extraNote: filteredExtraNote,
                  };
                }
              }
              return null;
            })
            .filter(Boolean);

          if (
            heading.heading.toLowerCase().includes(searchQuery.toLowerCase()) ||
            filteredContent?.length > 0 ||
            filteredSubHeadings?.length > 0
          ) {
            const checkMatch = getContextAroundMatch(
              heading.heading,
              searchQuery
            );
            if (checkMatch !== null) {
              match = checkMatch;
            }
            if (match !== null) {
              return {
                ...heading,
                content: filteredContent,
                subHeadings: filteredSubHeadings,
                match,
              };
            } else {
              return {
                ...heading,
                content: filteredContent,
                subHeadings: filteredSubHeadings,
              };
            }
          }
          return null;
        })
        .filter(Boolean);

      if (filteredHeadings.length > 0) {
        return {
          ...section,
          headings: filteredHeadings,
        };
      }
      return null;
    })
    .filter(Boolean);

  return results;
}

// Escape special regex characters in the query
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export const HighlightedText = ({ text, query }) => {
  if (!query) {
    return <span>{text}</span>;
  }

  const words = query.split(" ").filter(Boolean).map(escapeRegExp); // escape each word
  let regexStr = words.map((word) => `(${word})`).join("|");
  const regex = new RegExp(regexStr, "gi");

  const parts = text.split(regex).filter(Boolean);

  return (
    <span>
      {parts.map((part, index) =>
        regex.test(part) ? (
          <span className="text-primary" key={index}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </span>
  );
};

export const getHeaders = (includeApiKey = false) => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA== ",
    ...(includeApiKey && {
      "x-api-key":
        "12kXk3Xiou6Z50k0HSFZ5D8CScq2w6xJThdasldkfjaltht33223Dktkslsk",
    }),
  },
});

export function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[\s\W-]+/g, "-") // Replace spaces and non-word characters with hyphens
    .replace(/^-+|-+$/g, ""); // Trim leading/trailing hyphens
}
